import { useMemo } from 'react';

import useAxios from 'axios-hooks';

import { url } from 'constants/index';
import { RoundData } from 'features/rounds';
import { buildRequestParams } from 'utils/pagination.utils';

export const useRoundsTrimmed = (filters?: Array<PaginationFilter>, manual = false) => {
  filters = filters ?? [];
  filters.push({
    columnId: 'endDate',
    condition: 'gte',
    value: '2021-01-01',
  });
  const [{ data, loading: isLoading, error }] = useAxios<PaginationData<RoundData>>(
    {
      url: url.rounds,
      params: buildRequestParams({ pageSize: 200, filters }),
    },
    {
      manual,
    },
  );

  const rounds = useMemo(
    () => data?.items.map(({ id, name }) => ({ id, name })) || [],
    [data?.items],
  );

  return { rounds, error, isLoading };
};
